import React from 'react';
import { Container, Box, Flex, Text, Stack, Image } from '@chakra-ui/react';

import HomeCountdown from '../components/HomeCountdown';

import Vector from '../assets/images/smart-object.png';
import Tohum from '../assets/images/tohum-nasil-uretilir.jpg';
import Drone from '../assets/images/drone.jpg';
import Cevre from '../assets/images/cevre-tescil.jpeg';

function Homepage() {
    return (
        <Flex flexDirection="column">
            <HomeCountdown />
            <Container maxW="6xl" centerContent>
                <Box w="100%" my={20}>
                    <Image src={Cevre} width="100%" />
                </Box>
                <Box padding="4" maxW="4xl" textAlign="center">
                    <Stack spacing={3}>
                        <Text fontSize={{ base: 'md', md: 'xl' }}>
                            Rebul Şirketler Grubu, güzellik ve ürünlerin “cruelty free” olması
                            gerektiğine inanmaktadır. Küresel bir program olan Leaping Bunny onayı,
                            “cruelty free” standartlarını ve yasal yükümlülükleri gerektirir. Bizler
                            de, Leaping Bunny sertifikalı olmaktan gurur duyuyoruz. Tüm kozmetik ve
                            kişisel bakım ürünlerimiz; “cruelty free” ürünleri için uluslararası
                            altın standart olarak kabul görülen Cruelty Free International Leaping
                            Bunny programı altında onaylanmıştır. Sabit bir tarih politikasına bağlı
                            kalarak, tüm ürünlerimizin Leaping Bunny kriterlerine devam etmesini
                            sağlamak için tedarikçilerimizi proaktif olarak izliyoruz. Tedarikçi
                            izleme sistemimiz bağımsız olarak denetlenmektedir. Cruelty Free
                            International, Leaping Bunny ve Leaping Bunny standartları hakkında daha
                            fazla bilgi için{' '}
                            <a
                                href="https://www.crueltyfreeinternational.org"
                                target="_blank"
                                rel="noreferrer"
                                style={{ color: 'red' }}
                            >
                                www.crueltyfreeinternational.org
                            </a>{' '}
                            ziyaret edebilirsiniz.
                        </Text>
                        <hr style={{ border: '1px solid black' }} />
                        <Text fontSize={{ base: 'md', md: 'xl' }}>
                            Bu muhteşem gezegen bize sunduklarıyla kocaman bir teşekkürü hak ediyor
                            bizce. Oysa gezegenimizin bize sunduğu eşsiz olanakları ne yazık ki hep
                            birlikte bıraktığımız karbon ayak izimizle geri dönüşü çok zor bir
                            şekilde tüketiyoruz.
                        </Text>
                        <Text fontSize={{ base: 'md', md: 'xl' }}>#gezegenetesekkur</Text>
                        <Text fontSize={{ base: 'md', md: 'xl' }}>
                            Rebul Şirketler Grubu olarak Sürdürülebilirlik Eforları Programımız
                            çerçevesinde sizlerle birlikte dev bir proje başlatıyoruz. Orman Genel
                            Müdürlüğü ARGE’si ve Ecording teknik altyapısıyla yürüttüğümüz bu proje
                            ile teknolojiyi gezegene faydalı bir araç olarak kullanıp insansız hava
                            araçlarıyla fidanlamanın mümkün olmadığı ulaşılmaz alanlara tam 500.000
                            tohum topu gönderiyoruz.
                        </Text>
                        <Text fontSize={{ base: 'md', md: 'xl' }}>
                            Aldığınız her Rebul ürünü ile sizin için rezervimizde bulundurduğumuz
                            tohumlardan bir tanesi, bu alanlara bırakılacak.
                        </Text>
                        <Text fontSize={{ base: 'md', md: 'xl' }}>
                            {' '}
                            Üstelik 28 Nisanda başlayacak bu tohumlama uçuşlarında atılan tohum
                            toplarını web sitemizdeki sayaçtan da izleyebileceksiniz.
                        </Text>
                    </Stack>
                </Box>
                <Flex
                    flexDirection="column"
                    padding="4"
                    maxW="6xl"
                    textAlign="center"
                    backgroundColor="#DCF2E2"
                    alignItems="center"
                    my={10}
                >
                    <Text fontSize={{ base: 'xl', md: '2xl' }} fontWeight="bold">
                        Tohum topu Nedir?
                    </Text>
                    <Text fontSize={{ base: 'md', md: 'xl' }}>
                        Bir tohumun etrafının; içerisinde kil, gübre, humuslu toprak ve tohum
                        türünün verimliliği için özel belirlenen minerallerin yer aldığı bir karışım
                        ile kaplanması sonucu meydana gelen toplardır.
                    </Text>
                    <Box my="40px">
                        <Image src={Vector} />
                    </Box>
                    <Text fontSize={{ base: 'md', md: 'xl' }}>
                        Tohumların çimlenmesini iyileştirebilmek ve hızlandırmak için AR-GE
                        çalışmaları yapılmış türlerden tedarik edilen tohumlar; kil, toz gübre,
                        çeşitli mineraller, bölgeden alınan orman toprağı ve tohum türleri için özel
                        olarak hazırlamış karışımla kaplanmaktadır. Belirli sıkma oranlarında misket
                        büyüklüğünde toplar haline getirildikten sonra ekim günlerine kadar sabit
                        sıcaklıktaki dolaplarda bekletilmekte ve ekim zamanı gelen her bir tohum
                        topunun içerisine mineralli su enjekte edilmektedir.
                    </Text>
                </Flex>
                <Flex
                    flexDirection={{ base: 'column', lg: 'row' }}
                    padding="4"
                    maxW="6xl"
                    textAlign="center"
                    alignItems="center"
                    my={10}
                >
                    <Box w={{ base: '100%', lg: '50%' }}>
                        <Image src={Tohum} />
                    </Box>
                    <Box w={{ base: '100%', lg: '50%' }} p={{ base: 1, md: 5 }}>
                        <Text fontSize={{ base: 'xl', md: '2xl' }} fontWeight="bold">
                            Tohum topları nasıl üretiliyor?
                        </Text>
                        <Text fontSize={{ base: 'md', md: 'xl' }}>
                            İklim krizinden kaynaklı gelir eşitsizliği yaşayan gruplardan biri de
                            kırsal bölgelerde yaşayan insanlardır. Geçim kaynakları çoğunlukla tarım
                            ve hayvancılık olan bu kesim, küresel iklim krizinden doğrudan
                            etkilendiği için gelir eşitsizliği ile de karşı karşıya kalmaktadır.
                            Ekim sahalarımıza yakın bölgelerde yaşayan ve iklim krizi nedeni ile
                            gelir eşitsizliğine maruz kalan kadınlara, tohum toplarının üretimi için
                            özel olarak geliştirilen materyallerin eğitimleri veriliyor ve söz
                            konusu kadınlar ile tohum toplarının üretimi gerçekleştiriliyor.
                            Ardından üretilen tohum toplarının söz konusu kadınlardan satın alınması
                            ile birlikte Orman Genel Müdürlüğü tarafından belirlenen sahalarda ekim
                            operasyonları gerçekleştiriliyor. Böylelikle, küresel iklim krizinden
                            olumsuz etkilenen kadınların ek gelir elde etmesine katkıda bulunuluyor
                            ve iklim krizine karşı kadınlar ile birlikte doğrudan mücadele ediliyor.
                        </Text>
                    </Box>
                </Flex>
                <Flex
                    flexDirection={{ base: 'column', lg: 'row' }}
                    padding="4"
                    maxW="6xl"
                    textAlign="center"
                    alignItems="center"
                    my={10}
                    backgroundColor="#DCF2E2"
                >
                    <Box w={{ base: '100%', md: '50%' }} p={{ base: 1, md: 5 }}>
                        <Text fontSize={{ base: 'xl', md: '2xl' }} fontWeight="bold">
                            Neden tohum topu atışı gerçekleştiriliyor?
                        </Text>
                        <Text fontSize={{ base: 'md', md: 'xl' }} my={5}>
                            Tohumların söz konusu şekilde etraflarının kaplanması sayesinde; soğuk,
                            aşırı sıcak, rüzgar, orman canlılarının tohumu yemesi gibi şartlardan
                            minimum maliyetle korunmaları sağlanmaktadır. Ayrıca tohumun
                            çimlenebilmesi için sıcaklık ve nem açısından, dış ortam koşullarından
                            bağımsız olarak kendi içerisinde uygun bir ortam yaratmaktadır.
                        </Text>
                    </Box>
                    <Box w={{ base: '100%', md: '50%' }}>
                        <Image src={Drone} />
                    </Box>
                </Flex>
            </Container>
        </Flex>
    );
}

export default Homepage;
